import ServiceScreen from './index';

const routes = [
  {
    path: '/onboarding-services',
    component: ServiceScreen,
  },
];

export default routes;
